function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#492cbd;stroke:#492cbd;stroke-width:.1px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "diamond-2",
  "data-name": "diamond",
  className: "cls-3",
  d: "M6.915 11.987a.346.346 0 0 1-.164-.041.162.162 0 0 1-.032-.022l-.014-.011-.02-.013a.112.112 0 0 1-.032-.024L.084 4.548a.326.326 0 0 1-.026-.4l2.766-4a.324.324 0 0 1 .112-.1.128.128 0 0 1 .028-.01l.018-.007L3 .022A.176.176 0 0 1 3.055 0H3.1a.036.036 0 0 1 .012 0h7.664a.187.187 0 0 1 .051.017l.023.01.018.006a.146.146 0 0 1 .023.009.324.324 0 0 1 .113.1l2.766 4a.322.322 0 0 1-.025.4l-6.57 7.328a.13.13 0 0 1-.032.023l-.021.013-.009.008a.174.174 0 0 1-.036.025.346.346 0 0 1-.162.048zm-2.6-7.324 2.6 6.116 2.6-6.116zm5.941 0L8.037 9.9l4.693-5.235h-2.47zm-9.159 0L5.795 9.9 3.571 4.663zm9.816-3.445L10.435 4h2.4l-1.918-2.781zm-4-.331L4.495 4h4.841zm-4 .331L.991 4H3.4zM7.607.666l2.212 2.841.492-2.841h-2.7zm-4.087 0 .491 2.841L6.224.666z",
  transform: "rotate(25.97 -21.082 54.644)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "diamond-3",
  "data-name": "diamond",
  className: "cls-3",
  d: "M6.454 11.065a.326.326 0 0 1-.153-.038.151.151 0 0 1-.029-.02L6.259 11l-.019-.012a.1.1 0 0 1-.03-.023L.078 4.2a.3.3 0 0 1-.024-.372L2.635.137a.3.3 0 0 1 .1-.091.121.121 0 0 1 .031-.011l.017-.006L2.8.02A.166.166 0 0 1 2.852 0H10.053a.176.176 0 0 1 .047.02l.021.009.016.006.022.008a.3.3 0 0 1 .106.091l2.582 3.689a.3.3 0 0 1-.023.372L6.7 10.963a.121.121 0 0 1-.03.021L6.65 11h-.009a.163.163 0 0 1-.034.023.326.326 0 0 1-.153.042zM4.031 4.3l2.424 5.65L8.878 4.3zm5.545 0L7.5 9.137 11.881 4.3h-2.3zm-8.548 0 4.38 4.837L3.333 4.3zm9.161-3.18L9.74 3.69h2.243l-1.794-2.565zM6.455.82 4.2 3.69h4.514zm-3.735.305L.925 3.69h2.244zM7.1.615l2.065 2.623.459-2.623H7.1zm-3.814 0 .458 2.623L5.809.615z",
  transform: "rotate(-17 55.062 8.229)"
});

function SvgSellerAcc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_8954",
    "data-name": "Group 8954",
    transform: "translate(0 -.215)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_834",
    "data-name": "Ellipse 834",
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    transform: "translate(0 .215)",
    style: {
      opacity: 0.063,
      fill: "#492cbd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9117",
    "data-name": "Group 9117",
    transform: "translate(8.299 11.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "diamond",
    d: "M8.759 14.754a.448.448 0 0 1-.208-.051.205.205 0 0 1-.04-.027l-.018-.013-.025-.016a.142.142 0 0 1-.04-.03L.106 5.6a.392.392 0 0 1-.033-.5L3.577.183h.006a.407.407 0 0 1 .141-.125.166.166 0 0 1 .03-.011l.023-.009.028-.011A.228.228 0 0 1 3.87.006h.042a.044.044 0 0 0 .014 0 .047.047 0 0 1 .016 0h9.636a.048.048 0 0 1 .015 0H13.65a.241.241 0 0 1 .064.021l.029.012.022.008a.188.188 0 0 1 .03.011.408.408 0 0 1 .143.121l3.5 4.919a.388.388 0 0 1-.032.5l-8.314 9.019a.164.164 0 0 1-.04.029.254.254 0 0 0-.027.016l-.012.01a.221.221 0 0 1-.046.031.449.449 0 0 1-.208.051zM5.47 5.74l3.29 7.527 3.289-7.527zm7.53 0-2.82 6.443 5.944-6.443H13zm-11.6 0 5.94 6.443L4.523 5.74zM13.828 1.5l-.609 3.42h3.044L13.828 1.5zM8.76 1.093 5.694 4.92h6.132zM3.691 1.5 1.256 4.92H4.3zM9.635.819l2.8 3.5.623-3.5H9.635zM4.458.82l.622 3.5 2.8-3.5z",
    transform: "translate(9.634)",
    style: {
      fill: "#492cbd"
    }
  }), _ref3, _ref4)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellerAcc);
export default __webpack_public_path__ + "static/media/seller-acc.46491c1b.svg";
export { ForwardRef as ReactComponent };